var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 60,
    viewBox: "0 0 39 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 0H6.5C4.77609 0 3.12279 0.677294 1.90381 1.88289C0.68482 3.08848 0 4.72361 0 6.42857V53.5714C0 55.2764 0.68482 56.9115 1.90381 58.1171C3.12279 59.3227 4.77609 60 6.5 60H32.5C34.2239 60 35.8772 59.3227 37.0962 58.1171C38.3152 56.9115 39 55.2764 39 53.5714V6.42857C39 4.72361 38.3152 3.08848 37.0962 1.88289C35.8772 0.677294 34.2239 0 32.5 0ZM34.6667 53.5714C34.6667 54.1397 34.4384 54.6848 34.0321 55.0867C33.6257 55.4885 33.0746 55.7143 32.5 55.7143H6.5C5.92536 55.7143 5.37426 55.4885 4.96794 55.0867C4.56161 54.6848 4.33333 54.1397 4.33333 53.5714V6.42857C4.33333 5.86025 4.56161 5.31521 4.96794 4.91334C5.37426 4.51148 5.92536 4.28571 6.5 4.28571H32.5C33.0746 4.28571 33.6257 4.51148 34.0321 4.91334C34.4384 5.31521 34.6667 5.86025 34.6667 6.42857V53.5714ZM30.3333 10.7143C30.3333 11.2826 30.1051 11.8277 29.6987 12.2295C29.2924 12.6314 28.7413 12.8571 28.1667 12.8571H10.8333C10.2587 12.8571 9.7076 12.6314 9.30127 12.2295C8.89494 11.8277 8.66667 11.2826 8.66667 10.7143C8.66667 10.146 8.89494 9.60092 9.30127 9.19906C9.7076 8.79719 10.2587 8.57143 10.8333 8.57143H28.1667C28.7413 8.57143 29.2924 8.79719 29.6987 9.19906C30.1051 9.60092 30.3333 10.146 30.3333 10.7143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppDesign);
export default __webpack_public_path__ + "static/media/AppDesign.76df0bcf7fddaaffec3a51b4a7a45d51.svg";
export { ForwardRef as ReactComponent };